export interface QuestionaireApiModel {
    [key: number]: number
}